import * as React from "react";
import Grid from "@mui/material/Grid";
import { Paper } from "@mui/material";
import LinearProgressBar from "../../shared/linearProgress/LinearProgress";
import { useTranslation } from "react-i18next";

export default function BoxSx({
  Estimated_Probability,
  pourcentage_of_affected_assets,
  pourcentage_of_high_or_higher_risks,
}) {
  const { t } = useTranslation();
  const getPourcentage = (num) => {
    return Math.round(parseFloat(num) * 100 * 100) / 100;
  };
  return (
    <div
      style={{
        display: "flex",
        transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;",
        color: "#121828",
        borderRadius: "8px",
        boxShadow:
          "0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)",
        padding: "16px",
        margin: "auto",
        backgroundColor: "#F5F7FB",
        minHeight: "220px",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <span style={{ fontWeight: "600", fontSize: "20px" }}>
            {t("additional_score")}
          </span>
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px 0px",
            }}
          >
            {" "}
            <span>{t("assets_impacted")}</span>
            <span>{getPourcentage(pourcentage_of_affected_assets)}%</span>
          </div>
          <LinearProgressBar
            value={getPourcentage(pourcentage_of_affected_assets)}
          ></LinearProgressBar>
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px 0px",
            }}
          >
            {" "}
            <span>{t("identified_risk")}</span>
            <span>{getPourcentage(pourcentage_of_high_or_higher_risks)}%</span>
          </div>
          <LinearProgressBar
            value={getPourcentage(pourcentage_of_high_or_higher_risks)}
          ></LinearProgressBar>
        </Grid>
        <Grid item xs={12}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "5px 0px",
            }}
          >
            {" "}
            <span>{t("estimated_probability")}</span>
            <span>{getPourcentage(Estimated_Probability)}%</span>
          </div>
          <LinearProgressBar
            value={getPourcentage(Estimated_Probability)}
          ></LinearProgressBar>
        </Grid>
      </Grid>
    </div>
  );
}
